import { ReactNode, useLayoutEffect, useRef, useState } from "react";

/** Anchor sticky indicators across the report without reserving header height. */
export function ReportIndicators({ children, busy }: { children: ReactNode; busy: boolean }) {
  const slotRef = useRef<HTMLElement>(null);
  const [placement, setPlacement] = useState({ top: 0, width: 280 });

  useLayoutEffect(() => {
    const slot = slotRef.current;
    const report = slot?.closest("form");
    if (!slot || !report) return;

    const measure = () => {
      if (window.matchMedia("print").matches) return;
      const slotBounds = slot.getBoundingClientRect();
      const next = {
        top: slotBounds.top - report.getBoundingClientRect().top,
        width: slotBounds.width,
      };
      setPlacement(previous => previous.top === next.top && previous.width === next.width ? previous : next);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(slot);
    observer.observe(report);
    window.addEventListener("resize", measure);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <aside className="report-indicators-slot" ref={slotRef} aria-busy={busy}>
      <div className="report-indicators" style={{ top: placement.top, width: placement.width }}>
        <div className="report-indicators__content">{children}</div>
      </div>
    </aside>
  );
}
